import {
  createMetaTheme
} from "./chunk-QFOFFWMP.mjs";
import {
  primitiveColor
} from "./chunk-TUU3BKKT.mjs";

// src/themes/b2bDark.ts
var b2bDark = createMetaTheme({
  colors: {
    brand: {
      strong: primitiveColor.pink[50],
      default: primitiveColor.pink[70],
      subtle: primitiveColor.pink[80],
      subtler: primitiveColor.pink[90],
      subtlest: primitiveColor.pink[100],
      faint: "#FA506940"
    },
    status: {
      success: {
        default: primitiveColor.green[60],
        subtle: primitiveColor.green[70],
        subtler: primitiveColor.green[90],
        subtlest: primitiveColor.green[100]
      },
      warning: {
        default: primitiveColor.yellow[60],
        subtle: primitiveColor.yellow[70],
        subtler: primitiveColor.yellow[90],
        subtlest: primitiveColor.yellow[100]
      },
      error: {
        default: primitiveColor.red[60],
        subtle: primitiveColor.red[70],
        subtler: primitiveColor.red[90],
        subtlest: primitiveColor.red[100]
      },
      processing: {
        default: primitiveColor.blue[60],
        subtle: primitiveColor.blue[70],
        subtler: primitiveColor.blue[90],
        subtlest: primitiveColor.blue[100]
      }
    },
    text: {
      primary: primitiveColor.neutral[0],
      secondary: primitiveColor.neutral[20],
      tertiary: primitiveColor.neutral[50],
      quaternary: primitiveColor.neutral[60],
      inverse: primitiveColor.neutral[100]
    },
    icon: {
      primary: primitiveColor.neutral[0],
      secondary: primitiveColor.neutral[20],
      tertiary: primitiveColor.neutral[50],
      quaternary: primitiveColor.neutral[60],
      inverse: primitiveColor.neutral[100]
    },
    background: {
      default: primitiveColor.neutral[100],
      subtle: primitiveColor.neutral[90],
      modal: primitiveColor.neutral[90],
      popover: primitiveColor.neutral[80]
    },
    line: {
      clickable: primitiveColor.neutralWhiteAlpha[20],
      nonClickable: primitiveColor.neutralWhiteAlpha[12],
      selected: primitiveColor.neutral[20]
    },
    dimm: {
      default: primitiveColor.neutralBlackAlpha[60]
    },
    fill: {
      default: primitiveColor.neutralBlackAlpha[0],
      subtle: primitiveColor.neutralWhiteAlpha[12],
      inverse: {
        default: primitiveColor.neutral[0],
        subtle: primitiveColor.neutral[30]
      },
      transparent: primitiveColor.neutralBlackAlpha[0]
    }
  },
  effects: {},
  components: (baseTheme) => ({
    button: {
      solidSecondary: {
        background: primitiveColor.neutral[10],
        backgroundHover: primitiveColor.neutral[30],
        text: baseTheme.text.inverse,
        icon: baseTheme.icon.inverse
      },
      solidTertiary: {
        background: primitiveColor.neutral[80],
        backgroundHover: primitiveColor.neutral[70],
        text: baseTheme.text.secondary,
        icon: baseTheme.icon.secondary
      },
      outlinePrimary: {
        border: primitiveColor.neutral[10],
        background: primitiveColor.neutralBlackAlpha[0],
        backgroundHover: primitiveColor.neutralWhiteAlpha[12],
        text: baseTheme.text.primary,
        icon: baseTheme.icon.primary
      },
      outlineSecondary: {
        border: primitiveColor.neutral[60],
        background: primitiveColor.neutralBlackAlpha[0],
        backgroundHover: primitiveColor.neutralWhiteAlpha[12],
        text: baseTheme.text.secondary,
        icon: baseTheme.icon.secondary
      }
    },
    switch: {
      checkedBrand: {
        background: baseTheme.brand.default,
        backgroundHover: baseTheme.brand.strong
      },
      checkedGreen: {
        background: primitiveColor.green[70],
        backgroundHover: primitiveColor.green[60]
      },
      unchecked: {
        background: primitiveColor.neutral[70],
        backgroundHover: primitiveColor.neutral[60]
      }
    },
    bottomSheet: {
      grabber: {
        background: primitiveColor.neutral[80]
      }
    },
    spinner: {
      indicator: {
        color: primitiveColor.neutral[0]
      }
    },
    checkbox: {
      checked: {
        border: baseTheme.brand.default,
        background: baseTheme.brand.default,
        backgroundHover: baseTheme.brand.strong
      },
      unchecked: {
        border: primitiveColor.neutral[60],
        background: baseTheme.fill.default,
        backgroundHover: baseTheme.fill.subtle
      }
    },
    radioGroup: {
      checked: {
        accent: baseTheme.brand.default,
        accentHover: baseTheme.brand.strong,
        background: baseTheme.fill.default,
        backgroundHover: baseTheme.fill.subtle
      },
      unchecked: {
        accent: primitiveColor.neutral[60],
        accentHover: primitiveColor.neutral[60],
        background: baseTheme.fill.default,
        backgroundHover: baseTheme.fill.subtle
      }
    }
  })
});

export {
  b2bDark
};
